export const COMMIT_ID = "";
export const BUILD_TIME = "2020-09-18T09:45+00:00";
